import React from 'react';
import { useSelector } from 'react-redux';
import { openReactModal } from '@/actions';
import css from '@/css/module/new-world.css';
import {
  BAR,
  BARLINE,
  LINE,
  PIE,
  PIVOT,
  STACKED_CHART,
  TABLE,
} from '@/components/charting/chartType.constants';
import CellContentModal from '@/components/CellContentModal';
import { OPEN_TABLE_CELL_VALUE } from '@/constants/custom-event-names';
import { useDataPresentationParam, useEventListener } from '@/hooks';

import Drilldown from '@/features/drilldown/Drilldown';
import { useAppDispatch } from '@/store/hooks';
import { TableDataPresentation } from '@/features/dataPresentation/views/TableDataPresentation';
import { PivotDataPresentation } from '@/features/dataPresentation/views/PivotDataPresentation';
import { SINGLE_VALUE } from '@/components/ChartHolder.constants';
import { SingleValueDataPresentation } from '@/features/dataPresentation/views/SingleValueDataPresentation';
import { PieDataPresentation } from '@/features/dataPresentation/views/PieDataPresentation';
import { BarDataPresentation } from '@/features/dataPresentation/views/BarDataPresentation';
import { LineDataPresentation } from '@/features/dataPresentation/views/LineDataPresentation';
import { BarLineDataPresentation } from '@/features/dataPresentation/views/BarLineDataPresentation';
import { getDataPresentation } from '@/store-selectors';

const DATA_PRESENTATION_TO_COMPONENT = {
  [TABLE]: TableDataPresentation,
  [PIVOT]: PivotDataPresentation,
  [SINGLE_VALUE]: SingleValueDataPresentation,
  [PIE]: PieDataPresentation,
  [BAR]: BarDataPresentation,
  [LINE]: LineDataPresentation,
  [BARLINE]: BarLineDataPresentation,
  [STACKED_CHART]: PieDataPresentation,
};

export type DataTableContainerProps = {
  chartContainerHeight?: number;
  isShareHTML?: boolean;
};

const DataPresentationContainer: React.FC<DataTableContainerProps> = ({
  chartContainerHeight,
  isShareHTML = false,
}) => {
  const dispatch = useAppDispatch();

  const dataPresentationState = useSelector(getDataPresentation);

  const dataPresentationParam = useDataPresentationParam();

  const dataPresentation = isShareHTML
    ? dataPresentationState
    : dataPresentationParam;

  const handleOpenCellValue = React.useCallback((event: Event) => {
    const { value, columnType } = (event as CustomEvent).detail;

    dispatch(
      openReactModal(
        <CellContentModal columnType={columnType} value={value} />,
      ),
    );
  }, []);

  useEventListener(OPEN_TABLE_CELL_VALUE, handleOpenCellValue);

  const width100 = dataPresentation !== TABLE ? ' full-width ' : '';

  const DataPresentation =
    // @ts-expect-error: TODO: fix.
    DATA_PRESENTATION_TO_COMPONENT[dataPresentation] ?? Drilldown;

  return (
    <div className={`${css.tableContainer} ${width100}`}>
      <DataPresentation chartContainerHeight={chartContainerHeight} />
    </div>
  );
};

export default DataPresentationContainer;
